import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Community, DiscussionListConfig } from "../../../../shared";

@Component({
  selector: "latest-discussions",
  templateUrl: "./latest-discussions.component.html",
})
export class LatestDiscussionsComponent implements OnInit {
  public community: Community;
  public config: DiscussionListConfig = new DiscussionListConfig();

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.parent.data.subscribe((data: { community: Community }) => {
      this.community = data.community;
      this.config.filters.community = this.community.name;
    });
  }
}
